export const style = {
  h4: {
    color: `black`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/GroupForm/style/ColorBlind/headers.js